import { useContext } from "react";
import { useState } from "react";
import { ArrowLeft, ArrowRight, CreditCard, Envelope, Eye, EyeSlash, Lock, PersonCircle, PhoneFill, Reply } from "react-bootstrap-icons";
import UserContext from "../contexts/UserContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { Spinner } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Player } from "@lottiefiles/react-lottie-player";
import { useEffect } from "react";
import { config } from "../constants/config";
import { textes } from "../constants/textes";
import OtpInput from 'react-otp-input';


export default function Login() {
    // states
    const location = useLocation();
    const sessionmsg = location?.state;

    const [conditionstate, setconditionstate] = useState(false);
    const [inscrptstate, setinscrptstate] = useState(false);
    const [confirmstate, setconfirmstate] = useState(false);
    const [forgotpassstate, setforgotpassstate] = useState(false);
    const [ressetpassstate, setressetpassstate] = useState(false);

    const [isforget, setisforget] = useState(false);

    const [fetching, setFetching] = useState(false);
    const [loging, setLoging] = useState(false);

    const [firstname, setfirstname] = useState('');
    const [lastname, setlastname] = useState('');
    const [email, setemail] = useState('');
    const [numpi, setnumpi] = useState('');
    const [passport, setpassport] = useState('');
    const [pass, setpass] = useState('');
    const [confirmpass, setconfirmpass] = useState('');
    const [rectocni, setrectocni] = useState('');
    const [versocni, setversocni] = useState('');
    const [passportimg, setpassportimg] = useState('');
    const [pub, setpub] = useState(false);
    const [fa, setfa] = useState(false);
    const [vpn, setvpn] = useState(false);
    const [accept, setaccept] = useState(false);
    const [typeident, settypeident] = useState('');
    const listtypeident = [
        { label: "Carte nationale d'identité", value: 0 },
        { label: "Passeport", value: 1 },
    ];
    const [inscriptstep, setinscriptstep] = useState(0);

    const [otp, setotp] = useState('');

    const [showpass, setShowpass] = useState(false);
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [step, setStep] = useState(0);
    const [profils, setProfils] = useState([]);
    // const [ruleslist, setRuleslist] = useState([]);
    const { user, loginUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [userlog, setUserlog] = useState({ code: "", nom: "", login: "", });
    const [cmpte, setCmpte] = useState('');
    const [profil, setprofil] = useState('');
    const [tk, settk] = useState('');
    const [espa, setespa] = useState('');
    const [tel, settel] = useState('');
    const [codeuser, setcodeuser] = useState('');


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showWarningMessage = (msg) => {
        toast.warning(msg, {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const handleChangeFile = (e, input) => {
        const file = e.target.files[0];
        TransformFile(file, input);
    };

    const TransformFile = (file, input) => {
        const reader = new FileReader();
        if (input === "CNIRECTO") {
            if (file) {
                reader.readAsDataURL(file);
                reader.onloadend = () => {
                    setrectocni(reader.result);
                };
            } else {
                setrectocni(null);
            }
        } else if (input === "CNIVERSO") {
            if (file) {
                reader.readAsDataURL(file);
                reader.onloadend = () => {
                    setversocni(reader.result);
                };
            } else {
                setversocni(null);
            }
        } else if (input === "PASSEPORT") {
            if (file) {
                reader.readAsDataURL(file);
                reader.onloadend = () => {
                    setpassportimg(reader.result);
                };
            } else {
                setpassportimg(null);
            }
        }

    };

    const handleaccept = () => {
        setaccept(!accept);
    };

    const handlepub = () => {
        setpub(!pub);
    };

    const handlefa = () => {
        setfa(!fa);
    };

    const handlevpn = () => {
        setvpn(!vpn);
    };


    // comportements
    useEffect(() => {
        if (user != null) {
            navigate("/");
        }
    }, [user]);

    const handleSignin = async (e) => {
        e.preventDefault();

        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);

        var urlencoded = new URLSearchParams();
        urlencoded.append("nom", firstname);
        if (lastname) urlencoded.append("prenom", lastname);
        urlencoded.append("email", email);
        urlencoded.append("numtel", "+237" + tel);
        if (numpi) urlencoded.append("numcni", numpi);
        if (passport) urlencoded.append("numpasseport", passport);
        if (passportimg) urlencoded.append("imgpasseport", passportimg);
        if (rectocni) urlencoded.append("rectocni", rectocni);
        if (versocni) urlencoded.append("versocni", versocni);
        urlencoded.append("fa", fa);
        urlencoded.append("pub", pub);
        urlencoded.append("vpn", vpn);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/inscriptions`, requestOptions).then((response) => {
            if (response?.status === 200 || response?.status === 201) {
                response.json().then(async (data) => {
                    // console.log("resonse ajout droit", data);
                    if (!data?.head) {
                        setFetching(false);
                        showErrorMessage(data?.body?.data?.msg);
                    } else {
                        showSuccesMessage("Inscription réussie");
                        setFetching(false);
                        setcodeuser(data?.body?.data?.creerutilisateur)
                        setinscrptstate(false);
                        setconfirmstate(true);
                    }

                });
            } else {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
            }

        }).catch((err) => {
            // console.log("catch signin error", err);
            // setError(true);
            showErrorMessage(textes.fr.serviceunavaillable);
            setFetching(false);
        });

    }

    const handleConfirmSignin = async (e) => {
        e.preventDefault();

        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);

        var urlencoded = new URLSearchParams();
        if (!isforget) {
            // urlencoded.append("codeutilisateur", codeuser);
            urlencoded.append("codeopt", otp);
            urlencoded.append("mdp", pass);
            urlencoded.append("email", email);
            urlencoded.append("nom", lastname ? firstname + " " + lastname : firstname);
            urlencoded.append("etat", "1");
            urlencoded.append("etatdef", "Vérifié");

            var requestOptions = {
                method: 'PATCH',
                headers: myHeaders,
                body: urlencoded,
                redirect: 'follow'
            };

            // console.log("data send", urlencoded)

            await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/inscriptions/${codeuser}`, requestOptions).then((response) => {
                if (response?.status === 205) {
                    showSuccesMessage("Confirmation réussie");
                    setFetching(false);
                    handleLoginSignin(email, pass);
                } else if (response?.status === 200) {
                    response.json().then(async (data) => {
                        setFetching(false);
                        showErrorMessage(data?.body?.data?.msg);

                    });
                } else {
                    // setError(true);
                    showErrorMessage(textes.fr.serviceunavaillable);
                    setFetching(false);
                }

            }).catch((err) => {
                // console.log("catch confirm account error", err);
                // setError(true);
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
            });
        } else {

            urlencoded.append("login", email);
            urlencoded.append("mdp", otp);

            var requestOptions2 = {
                method: 'POST',
                headers: myHeaders,
                body: urlencoded,
                redirect: 'follow'
            };

            // console.log("data send", urlencoded)

            await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/login`, requestOptions2).then((response) => {
                if (response?.status !== 201) {
                    // console.log("resonse test ", response);
                    // console.log("resonse statut ", response?.status);
                    // setError(true);
                    showErrorMessage(textes.fr.serviceunavaillable);
                    setFetching(false);
                } else {
                    response.json().then(async (data) => {
                        // console.log(`données en retour: ${JSON.stringify(data)}`);
                        let body = data?.body?.data;

                        if (data?.head) {

                            if (!body?.ident) {
                                showErrorMessage(textes.fr.invalidlogin);
                            } else if (body?.ident && !body?.auth) {
                                showErrorMessage(textes.fr.wrongpassword);
                            } else if (body?.ident && body?.auth && body?.bloq) {
                                showWarningMessage(textes.fr.desabledaccount);
                            } else {
                                // console.log("body: ", body);

                                setCmpte(body?.code);
                                setUserlog({ code: body?.code, nom: body?.nom, login: body?.login, photo: body?.photo, codeutilisateur: body?.util });


                                if (body?.prof.length === undefined || body?.prof.length === 0) {
                                    showWarningMessage(textes.fr.noprofilsfound)
                                } else {

                                    setCmpte(body?.code);
                                    setprofil(body?.prof[0]?.code);
                                    setespa(body?.prof[0]?.esp);
                                    // setUserlog({ code: body?.code, nom: body?.nom, login: body?.login, client: body?.client, photo: body?.photo, codeutilisateur: body?.util });
                                    await confirmLoginOnProfileForgot(body?.prof[0]?.code, body?.code);

                                }

                            }

                        } else {
                            showErrorMessage(textes.fr.requestfail);
                            setFetching(false);
                        }
                        setFetching(false);

                    })
                }

            }).catch((err) => {
                // console.log("error222222222", err);
                // setError(true);
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
            });

            // urlencoded.append("codeutilisateur", codeuser);
            // urlencoded.append("codeopt", otp);
            // urlencoded.append("email", email);

            // var requestOptions2 = {
            //     method: 'PATCH',
            //     headers: myHeaders,
            //     body: urlencoded,
            //     redirect: 'follow'
            // };

            // // console.log("data send", urlencoded)

            // await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/forgetpass/${codeuser}`, requestOptions2).then((response) => {
            //     if (response?.status === 205) {
            //         showSuccesMessage("Confirmation réussie");
            //         setconfirmstate(false);
            //         setisforget(false);
            //         setFetching(false);
            //         setressetpassstate(true);
            //     } else if (response?.status === 200) {
            //         response.json().then(async (data) => {
            //             setFetching(false);
            //             showErrorMessage(data?.body?.data?.msg);

            //         });
            //     } else {
            //         // setError(true);
            //         showErrorMessage(textes.fr.serviceunavaillable);
            //         setFetching(false);
            //     }

            // }).catch((err) => {
            //     // console.log("catch confirm account error", err);
            //     // setError(true);
            //     showErrorMessage(textes.fr.serviceunavaillable);
            //     setFetching(false);
            // });
        }

    }

    const confirmLoginOnProfileForgot = async (profil, compte) => {

        // setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);

        var urlencoded = new URLSearchParams();
        urlencoded.append("codecompte", compte);
        urlencoded.append("codeprofil", profil);
        // if (ip) urlencoded.append("ip", ip);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };


        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/connections`, requestOptions).then((response) => {
            if (response?.status !== 201) {
                setFetching(false);
                showErrorMessage(textes.fr.serviceunavaillable);
            } else {
                response.json().then(async (data) => {
                    // console.log(`données en retour: ${JSON.stringify(data)}`);

                    if (data?.head) {
                        let body = data?.body?.data;
                        settk(body?.creerconnexion);
                        showSuccesMessage("Confirmation réussie");
                        setconfirmstate(false);
                        setisforget(false);
                        setFetching(false);
                        setressetpassstate(true);

                    } else {
                        showErrorMessage(textes.fr.requestfail);
                        setFetching(false);
                    }

                })
            }
        }).catch((err) => {
            // console.log(`erreur retourné: ${err}`);
            setFetching(false);
            showErrorMessage(textes.fr.serviceunavaillable);
        });

    }

    const handleLoginSignin = async (plogin, ppass) => {

        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);

        var urlencoded = new URLSearchParams();
        urlencoded.append("login", plogin);
        urlencoded.append("mdp", ppass);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/login`, requestOptions).then((response) => {
            if (response?.status !== 201) {
                // console.log("resonse test ", response);
                // console.log("resonse statut ", response?.status);
                // setError(true);
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
            } else {
                response.json().then(async (data) => {
                    // console.log(`données en retour: ${JSON.stringify(data)}`);
                    let body = data?.body?.data;

                    if (data?.head) {

                        if (!body?.ident) {
                            showErrorMessage(textes.fr.invalidlogin);
                        } else if (body?.ident && !body?.auth) {
                            showErrorMessage(textes.fr.wrongpassword);
                        } else if (body?.ident && body?.auth && body?.bloq) {
                            showWarningMessage(textes.fr.desabledaccount);
                        } else {
                            // console.log("body: ", body);

                            setCmpte(body?.code);
                            setUserlog({ code: body?.code, nom: body?.nom, login: body?.login, photo: body?.photo, codeutilisateur: body?.util });


                            if (body?.prof.length === undefined || body?.prof.length === 0) {
                                showWarningMessage(textes.fr.noprofilsfound)
                            } else if (body?.prof.length > 0 && body?.prof.length === 1) {

                                setCmpte(body?.code);
                                setUserlog({ code: body?.code, nom: body?.nom, login: body?.login, client: body?.client, photo: body?.photo, codeutilisateur: body?.util });
                                await confirmLoginOnProfile(body?.prof[0]?.code, body?.code, { code: body?.code, nom: body?.nom, login: body?.login, client: body?.client, photo: body?.photo, codeutilisateur: body?.util, espace: body?.prof[0]?.esp }, body?.prof[0]?.esp);


                            } else {
                                let profs = [];
                                profs = body?.prof;
                                setProfils(profs);
                                // setCmpte(body?.code);
                                // setUserlog({code: body?.code, nom: body?.nom, login: body?.login});
                                // userlog.token = "dkqljdkqjdlfkjqldkfjlqksjf";
                                // console.log("user to log2", userlog);
                                setFetching(false);
                                setStep(1);
                            }

                        }

                    } else {
                        showErrorMessage(textes.fr.requestfail);
                        setFetching(false);
                    }
                    setFetching(false);

                })
            }

        }).catch((err) => {
            // console.log("error222222222", err);
            // setError(true);
            showErrorMessage(textes.fr.serviceunavaillable);
            setFetching(false);
        });

    }

    const handleForgetpass = async (e) => {
        e.preventDefault();

        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);

        // var urlencoded = new URLSearchParams();
        // urlencoded.append("email", email);

        var requestOptions = {
            method: 'Get',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users/reset?crit=${email}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse ajout droit", data);
                    if (!data?.head) {
                        setFetching(false);
                        showErrorMessage(data?.body?.data?.msg);
                    } else {
                        setFetching(false);
                        setforgotpassstate(false);
                        setconfirmstate(true);
                        setisforget(true);
                    }

                });
            } else {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
            }

        }).catch((err) => {
            // console.log("catch signin error", err);
            // setError(true);
            showErrorMessage(textes.fr.serviceunavaillable);
            setFetching(false);
        });

    }

    const handleRessetPass = async (e) => {
        e.preventDefault();

        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", tk);
        myHeaders.append("cpte", cmpte);
        myHeaders.append("prof", profil);
        myHeaders.append("conn", espa);

        var urlencoded = new URLSearchParams();
        urlencoded.append("mdp", pass);
        // urlencoded.append("email", email);

        var requestOptions = {
            method: 'PATCH',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/accounts/${cmpte}`, requestOptions).then((response) => {
            if (response?.status === 205) {
                showSuccesMessage("Réinitialisation réussie");
                setFetching(false);
                handleLoginSignin(email, pass);
            } else if (response?.status === 200) {
                response.json().then(async (data) => {
                    setFetching(false);
                    showErrorMessage(data?.body?.data?.msg);

                });
            } else {
                // setError(true);
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
            }

        }).catch((err) => {
            // console.log("catch confirm account error", err);
            // setError(true);
            showErrorMessage(textes.fr.serviceunavaillable);
            setFetching(false);
        });

    }



    const handleLogin = async (e) => {
        e.preventDefault();

        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);

        var urlencoded = new URLSearchParams();
        urlencoded.append("login", login);
        urlencoded.append("mdp", password);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/login`, requestOptions).then((response) => {
            if (response?.status !== 201) {
                // console.log("resonse test ", response);
                // console.log("resonse statut ", response?.status);
                // setError(true);
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
            } else {
                response.json().then(async (data) => {
                    // console.log(`données en retour: ${JSON.stringify(data)}`);
                    let body = data?.body?.data;

                    if (data?.head) {

                        if (!body?.ident) {
                            showErrorMessage(textes.fr.invalidlogin);
                        } else if (body?.ident && !body?.auth) {
                            showErrorMessage(textes.fr.wrongpassword);
                        } else if (body?.ident && body?.auth && body?.bloq) {
                            showWarningMessage(textes.fr.desabledaccount);
                        } else {
                            // console.log("body: ", body);

                            setCmpte(body?.code);
                            setUserlog({ code: body?.code, nom: body?.nom, login: body?.login, photo: body?.photo, codeutilisateur: body?.util });


                            if (body?.prof.length === undefined || body?.prof.length === 0) {
                                showWarningMessage(textes.fr.noprofilsfound)
                            } else if (body?.prof.length > 0 && body?.prof.length === 1) {

                                setCmpte(body?.code);
                                setUserlog({ code: body?.code, nom: body?.nom, login: body?.login, client: body?.client, photo: body?.photo, codeutilisateur: body?.util });
                                await confirmLoginOnProfile(body?.prof[0]?.code, body?.code, { code: body?.code, nom: body?.nom, login: body?.login, client: body?.client, photo: body?.photo, codeutilisateur: body?.util, espace: body?.prof[0]?.esp }, body?.prof[0]?.esp);


                            } else {
                                let profs = [];
                                profs = body?.prof;
                                setProfils(profs);
                                // setCmpte(body?.code);
                                // setUserlog({code: body?.code, nom: body?.nom, login: body?.login});
                                // userlog.token = "dkqljdkqjdlfkjqldkfjlqksjf";
                                // console.log("user to log2", userlog);
                                setFetching(false);
                                setStep(1);
                            }

                        }

                    } else {
                        showErrorMessage(textes.fr.requestfail);
                        setFetching(false);
                    }
                    setFetching(false);

                })
            }

        }).catch((err) => {
            // console.log("error222222222", err);
            // setError(true);
            showErrorMessage(textes.fr.serviceunavaillable);
            setFetching(false);
        });

    }


    const confirmLogin = async (profil, espace) => {

        setLoging(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);

        var urlencoded = new URLSearchParams();
        urlencoded.append("codecompte", cmpte);
        urlencoded.append("codeprofil", profil);
        urlencoded.append("crypt", true);
        urlencoded.append("duree", "15 minutes");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };


        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/connections`, requestOptions).then((response) => {
            if (response?.status !== 201) {
                setLoging(false);
                showErrorMessage(textes.fr.serviceunavaillable);
            } else {
                response.json().then(async (data) => {
                    // console.log(`données en retour: ${JSON.stringify(data)}`);

                    if (data?.head) {
                        let body = data?.body?.data;

                        userlog.profil = profil;
                        userlog.espace = espace;
                        userlog.token = body?.creerconnexion;
                        // console.log("user connexion with token", userlog);  

                        // await loginUser(userlog);
                        // navigate("/");
                        handleAffectRules(profil, userlog, body?.creerconnexion, espace, cmpte);

                    } else {
                        showErrorMessage(textes.fr.requestfail);
                        setLoging(false);
                    }

                })
            }
        }).catch((err) => {
            // console.log(`erreur retourné: ${err}`);
            setLoging(false);
            showErrorMessage(textes.fr.serviceunavaillable);
        });

    }

    const confirmLoginOnProfile = async (profil, compte, userlogparam, espace) => {

        // setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);

        var urlencoded = new URLSearchParams();
        urlencoded.append("codecompte", compte);
        urlencoded.append("codeprofil", profil);
        urlencoded.append("crypt", true);
        urlencoded.append("duree", "15 minutes");
        // if (ip) urlencoded.append("ip", ip);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };


        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/connections`, requestOptions).then((response) => {
            if (response?.status !== 201) {
                setFetching(false);
                showErrorMessage(textes.fr.serviceunavaillable);
            } else {
                response.json().then(async (data) => {
                    // console.log(`données en retour: ${JSON.stringify(data)}`);

                    if (data?.head) {
                        let body = data?.body?.data;

                        userlogparam.profil = profil;
                        userlogparam.token = body?.creerconnexion;
                        // userlogparam.token = body?.creerconnexion;
                        // console.log("user connexion with token", userlogparam);  

                        await handleAffectRulesForOne(profil, userlogparam, body?.creerconnexion, espace, compte);
                        // handleAffectRulesForOne(profil, userlogparam, body?.creerconnexion, compte);

                    } else {
                        showErrorMessage(textes.fr.requestfail);
                        setFetching(false);
                    }

                })
            }
        }).catch((err) => {
            // console.log(`erreur retourné: ${err}`);
            setFetching(false);
            showErrorMessage(textes.fr.serviceunavaillable);
        });

    }

    const handleAffectRules = async (profil, userloginfos, token, espace, code) => {
        // setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", token);
        myHeaders.append("cpte", code);
        myHeaders.append("prof", profil);
        myHeaders.append("conn", espace);

        // var urlencoded = new URLSearchParams();
        // urlencoded.append("cpte", user.code);
        // urlencoded.append("prof", user.profil);
        // urlencoded.append("conn", user.token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/profiles/rights/${profil}`, requestOptions).then((response) => {

            if (response?.status !== 200) {
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
                setLoging(false);
            } else {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        if (data.body?.data?.length !== undefined) {
                            clientarray = data?.body?.data;
                        } else {
                            clientarray.push(data?.body);
                        }

                        if (clientarray?.length !== 0) {
                            await clientarray.forEach(element => {
                                if (element.actiondroit === "fullaction") {
                                    userloginfos.isFullAction = true;
                                } else if (element.actiondroit === "adminaction") {
                                    userloginfos.isAdminAction = true;
                                }

                                else if (element.actiondroit === "gererdroit") {
                                    userloginfos.isGererDroit = true;
                                } else if (element.actiondroit === "consulterdroit") {
                                    userloginfos.isConsulterDroit = true;
                                } else if (element.actiondroit === "creerdroit") {
                                    userloginfos.isCreerDroit = true;
                                } else if (element.actiondroit === "modifierdroit") {
                                    userloginfos.isModifierDroit = true;
                                } else if (element.actiondroit === "supprimerdroit") {
                                    userloginfos.isSupprimerDroit = true;
                                } else if (element.actiondroit === "rechercherdroit") {
                                    userloginfos.isRechercherDroit = true;
                                } else if (element.actiondroit === "consulterdroitsprofil") {
                                    userloginfos.isConsulterDroitsProfil = true;
                                } else if (element.actiondroit === "modifierdroitsprofil") {
                                    userloginfos.isModifierDroitsProfil = true;
                                } else if (element.actiondroit === "desaffecterdroitprofil") {
                                    userloginfos.isDesaffecterDroitProfil = true;
                                } else if (element.actiondroit === "consulterdroitsespacetravail") {
                                    userloginfos.isConsulterDroitsEspaceTravail = true;
                                } else if (element.actiondroit === "modifierdroitsespacetravail") {
                                    userloginfos.isModifierDroitsEspaceTravail = true;
                                } else if (element.actiondroit === "desaffecterdroitespacetravail") {
                                    userloginfos.isDesaffecterDroitEspaceTravail = true;
                                }

                                else if (element.actiondroit === "gererdomaine") {
                                    userloginfos.isGererDomaine = true;
                                } else if (element.actiondroit === "consulterdomaine") {
                                    userloginfos.isConsulterDomaine = true;
                                } else if (element.actiondroit === "creerdomaine") {
                                    userloginfos.isCreerDomaine = true;
                                } else if (element.actiondroit === "modifierdomaine") {
                                    userloginfos.isModifierDomaine = true;
                                } else if (element.actiondroit === "supprimerdomaine") {
                                    userloginfos.isSupprimerDomaine = true;
                                } else if (element.actiondroit === "rechercherdomaine") {
                                    userloginfos.isRechercherDomaine = true;
                                }

                                else if (element.actiondroit === "gererclient") {
                                    userloginfos.isGererClient = true;
                                } else if (element.actiondroit === "consulterclient") {
                                    userloginfos.isConsulterClient = true;
                                } else if (element.actiondroit === "creerclient") {
                                    userloginfos.isCreerClient = true;
                                } else if (element.actiondroit === "modifierclient") {
                                    userloginfos.isModifierClient = true;
                                } else if (element.actiondroit === "supprimerclient") {
                                    userloginfos.isSupprimerClient = true;
                                } else if (element.actiondroit === "rechercherclient") {
                                    userloginfos.isRechercherClient = true;
                                }

                                else if (element.actiondroit === "gereresptrav") {
                                    userloginfos.isGererEspTrav = true;
                                } else if (element.actiondroit === "consulteresptrav") {
                                    userloginfos.isConsulterEspTrav = true;
                                } else if (element.actiondroit === "creeresptrav") {
                                    userloginfos.isCreerEspTrav = true;
                                } else if (element.actiondroit === "modifieresptrav") {
                                    userloginfos.isModifierEspTrav = true;
                                } else if (element.actiondroit === "supprimeresptrav") {
                                    userloginfos.isSupprimerEspTrav = true;
                                } else if (element.actiondroit === "rechercheresptrav") {
                                    userloginfos.isRechercherEspTrav = true;
                                }

                                else if (element.actiondroit === "gererprofil") {
                                    userloginfos.isGererProfil = true;
                                } else if (element.actiondroit === "consulterprofil") {
                                    userloginfos.isConsulterProfil = true;
                                } else if (element.actiondroit === "creerprofil") {
                                    userloginfos.isCreerProfil = true;
                                } else if (element.actiondroit === "modifierprofil") {
                                    userloginfos.isModifierProfil = true;
                                } else if (element.actiondroit === "supprimerprofil") {
                                    userloginfos.isSupprimerProfil = true;
                                } else if (element.actiondroit === "rechercherprofil") {
                                    userloginfos.isRechercherProfil = true;
                                } else if (element.actiondroit === "modifierprofilcompte") {
                                    userloginfos.isModifierProfilCompte = true;
                                } else if (element.actiondroit === "desaffecterprofil") {
                                    userloginfos.isDesaffecterProfil = true;
                                } else if (element.actiondroit === "consulterprofilcompte") {
                                    userloginfos.isConsulterProfilCompte = true;
                                }

                                else if (element.actiondroit === "gererutilisateur") {
                                    userloginfos.isGererUtilisateur = true;
                                } else if (element.actiondroit === "consulterutilisateur") {
                                    userloginfos.isConsulterUtilisateur = true;
                                } else if (element.actiondroit === "creerutilisateur") {
                                    userloginfos.isCreerUtilisateur = true;
                                } else if (element.actiondroit === "modifierutilisateur") {
                                    userloginfos.isModifierUtilisateur = true;
                                } else if (element.actiondroit === "supprimerutilisateur") {
                                    userloginfos.isSupprimerUtilisateur = true;
                                } else if (element.actiondroit === "rechercherutilisateur") {
                                    userloginfos.isRechercherUtilisateur = true;
                                }

                                else if (element.actiondroit === "gererconnexion") {
                                    userloginfos.isGererConnexion = true;
                                } else if (element.actiondroit === "consulterconnexion") {
                                    userloginfos.isConsulterConnexion = true;
                                }

                                else if (element.actiondroit === "gererincrement") {
                                    userloginfos.isGererIncrement = true;
                                } else if (element.actiondroit === "creerincrement") {
                                    userloginfos.isCreerIncrement = true;
                                } else if (element.actiondroit === "supprimerincrement") {
                                    userloginfos.isSupprimerIncrement = true;
                                }

                                else if (element.actiondroit === "gerermouchard") {
                                    userloginfos.isGererMouchard = true;
                                } else if (element.actiondroit === "consultermouchard") {
                                    userloginfos.isConsulterMouchard = true;
                                }

                                else if (element.actiondroit === "gerercompte") {
                                    userloginfos.isGererCompte = true;
                                } else if (element.actiondroit === "consultercompte") {
                                    userloginfos.isConsulterCompte = true;
                                } else if (element.actiondroit === "creercompte") {
                                    userloginfos.isCreerCompte = true;
                                } else if (element.actiondroit === "modifiercompte") {
                                    userloginfos.isModifierCompte = true;
                                } else if (element.actiondroit === "supprimercompte") {
                                    userloginfos.isSupprimerCompte = true;
                                } else if (element.actiondroit === "suspendrecompte") {
                                    userloginfos.isSuspendreCompte = true;
                                } else if (element.actiondroit === "activercompte") {
                                    userloginfos.isActiverCompte = true;
                                } else if (element.actiondroit === "recherchercompte") {
                                    userloginfos.isRechercherCompte = true;
                                }

                                else if (element.actiondroit === "gererlicence") {
                                    userloginfos.isGererLicence = true;
                                } else if (element.actiondroit === "consulterlicence") {
                                    userloginfos.isConsulterLicence = true;
                                } else if (element.actiondroit === "creerlicence") {
                                    userloginfos.isCreerLicence = true;
                                } else if (element.actiondroit === "modifierlicence") {
                                    userloginfos.isModifierLicence = true;
                                } else if (element.actiondroit === "supprimerlicence") {
                                    userloginfos.isSupprimerLicence = true;
                                } else if (element.actiondroit === "suspendrelicence") {
                                    userloginfos.isSuspendreLicence = true;
                                } else if (element.actiondroit === "activerlicence") {
                                    userloginfos.isActiverLicence = true;
                                } else if (element.actiondroit === "acheverlicence") {
                                    userloginfos.isAcheverLicence = true;
                                } else if (element.actiondroit === "rechercherlicence") {
                                    userloginfos.isRechercherLicence = true;
                                } else if (element.actiondroit === "consulterlicenceclient") {
                                    userloginfos.isConsulterLicenceClient = true;
                                } else if (element.actiondroit === "gestioncontroleroomdps") {
                                    userloginfos.isConsulterControlRoom = true;
                                }

                                // gestion des droits de l'application rattaché à la sécurité

                                else if (element.actiondroit === "gererrevendeur") {
                                    userloginfos.isGererRevendeur = true;
                                } else if (element.actiondroit === "consulterrevendeur") {
                                    userloginfos.isConsulterRevendeur = true;
                                } else if (element.actiondroit === "creerrevendeur") {
                                    userloginfos.isCreerRevendeur = true;
                                } else if (element.actiondroit === "modifierrevendeur") {
                                    userloginfos.isModifierRevendeur = true;
                                } else if (element.actiondroit === "supprimerrevendeur") {
                                    userloginfos.isSupprimerRevendeur = true;
                                } else if (element.actiondroit === "importerrevendeur") {
                                    userloginfos.isImporterRevendeur = true;
                                } else if (element.actiondroit === "suspendrerevendeur") {
                                    userloginfos.isSuspendreRevendeur = true;
                                } else if (element.actiondroit === "activerrevendeur") {
                                    userloginfos.isActiverRevendeur = true;
                                }

                                else if (element.actiondroit === "gererabonnement") {
                                    userloginfos.isGererAbonnement = true;
                                } else if (element.actiondroit === "consulterabonnement") {
                                    userloginfos.isConsulterAbonnement = true;
                                } else if (element.actiondroit === "creerabonnement") {
                                    userloginfos.isCreerAbonnement = true;
                                } else if (element.actiondroit === "modifierabonnement") {
                                    userloginfos.isModifierAbonnement = true;
                                } else if (element.actiondroit === "supprimerabonnement") {
                                    userloginfos.isSupprimerAbonnement = true;
                                } else if (element.actiondroit === "importerabonnement") {
                                    userloginfos.isImporterAbonnement = true;
                                } else if (element.actiondroit === "suspendreabonnement") {
                                    userloginfos.isSuspendreAbonnement = true;
                                } else if (element.actiondroit === "activerabonnement") {
                                    userloginfos.isActiverAbonnement = true;
                                }

                                else if (element.actiondroit === "gerersite") {
                                    userloginfos.isGererSite = true;
                                } else if (element.actiondroit === "consultersite") {
                                    userloginfos.isConsulterSite = true;
                                } else if (element.actiondroit === "creersite") {
                                    userloginfos.isCreerSite = true;
                                } else if (element.actiondroit === "modifiersite") {
                                    userloginfos.isModifierSite = true;
                                } else if (element.actiondroit === "supprimersite") {
                                    userloginfos.isSupprimerSite = true;
                                } else if (element.actiondroit === "importersite") {
                                    userloginfos.isImporterSite = true;
                                } else if (element.actiondroit === "suspendresite") {
                                    userloginfos.isSuspendreSite = true;
                                } else if (element.actiondroit === "activersite") {
                                    userloginfos.isActiverSite = true;
                                } else if (element.actiondroit === "validersite") {
                                    userloginfos.isValiderSite = true;
                                }

                                else if (element.actiondroit === "gererhotspot") {
                                    userloginfos.isGererHotspot = true;
                                } else if (element.actiondroit === "consulterhotspot") {
                                    userloginfos.isConsulterHotspot = true;
                                } else if (element.actiondroit === "creerhotspot") {
                                    userloginfos.isCreerHotspot = true;
                                } else if (element.actiondroit === "modifierhotspot") {
                                    userloginfos.isModifierHotspot = true;
                                } else if (element.actiondroit === "supprimerhotspot") {
                                    userloginfos.isSupprimerHotspot = true;
                                } else if (element.actiondroit === "importerhotspot") {
                                    userloginfos.isImporterHotspot = true;
                                } else if (element.actiondroit === "suspendrehotspot") {
                                    userloginfos.isSuspendreHotspot = true;
                                } else if (element.actiondroit === "activerhotspot") {
                                    userloginfos.isActiverHotspot = true;
                                } else if (element.actiondroit === "validerhotspot") {
                                    userloginfos.isValiderHotspot = true;
                                }

                                else if (element.actiondroit === "gererforfait") {
                                    userloginfos.isGererForfait = true;
                                } else if (element.actiondroit === "consulterforfait") {
                                    userloginfos.isConsulterForfait = true;
                                } else if (element.actiondroit === "creerforfait") {
                                    userloginfos.isCreerForfait = true;
                                } else if (element.actiondroit === "modifierforfait") {
                                    userloginfos.isModifierForfait = true;
                                } else if (element.actiondroit === "supprimerforfait") {
                                    userloginfos.isSupprimerForfait = true;
                                } else if (element.actiondroit === "importerforfait") {
                                    userloginfos.isImporterForfait = true;
                                } else if (element.actiondroit === "suspendreforfait") {
                                    userloginfos.isSuspendreForfait = true;
                                } else if (element.actiondroit === "activerforfait") {
                                    userloginfos.isActiverForfait = true;
                                }

                                else if (element.actiondroit === "gerersouscription") {
                                    userloginfos.isGererSouscription = true;
                                } else if (element.actiondroit === "consultersouscription") {
                                    userloginfos.isConsulterSouscription = true;
                                }

                                else if (element.actiondroit === "gerertransaction") {
                                    userloginfos.isGererTransaction = true;
                                } else if (element.actiondroit === "consultertransaction") {
                                    userloginfos.isConsulterTransaction = true;
                                }

                                else if (element.actiondroit === "genererticket") {
                                    userloginfos.isGenererTicket = true;
                                } else if (element.actiondroit === "viderticket") {
                                    userloginfos.isViderTicket = true;
                                }

                                else if (element.actiondroit === "gererpublicite") {
                                    userloginfos.isGererPublicite = true;
                                } else if (element.actiondroit === "consulterpublicite") {
                                    userloginfos.isConsulterPublicite = true;
                                } else if (element.actiondroit === "creerpublicite") {
                                    userloginfos.isCreerPublicite = true;
                                } else if (element.actiondroit === "modifierpublicite") {
                                    userloginfos.isModifierPublicite = true;
                                } else if (element.actiondroit === "supprimerpublicite") {
                                    userloginfos.isSupprimerPublicite = true;
                                } else if (element.actiondroit === "importerpublicite") {
                                    userloginfos.isImporterPublicite = true;
                                } else if (element.actiondroit === "suspendrepublicite") {
                                    userloginfos.isSuspendrePublicite = true;
                                } else if (element.actiondroit === "activerpublicite") {
                                    userloginfos.isActiverPublicite = true;
                                } else if (element.actiondroit === "acheverpublicite") {
                                    userloginfos.isAcheverPublicite = true;
                                }

                                else if (element.actiondroit === "gerercomptevpn") {
                                    userloginfos.isGererCompteVPN = true;
                                } else if (element.actiondroit === "consultercomptevpn") {
                                    userloginfos.isConsulterCompteVPN = true;
                                } else if (element.actiondroit === "creercomptevpn") {
                                    userloginfos.isCreerCompteVPN = true;
                                } else if (element.actiondroit === "modifiercomptevpn") {
                                    userloginfos.isModifierCompteVPN = true;
                                } else if (element.actiondroit === "supprimercomptevpn") {
                                    userloginfos.isSupprimerCompteVPN = true;
                                } else if (element.actiondroit === "importercomptevpn") {
                                    userloginfos.isImporterCompteVPN = true;
                                } else if (element.actiondroit === "suspendrecomptevpn") {
                                    userloginfos.isSuspendreCompteVPN = true;
                                } else if (element.actiondroit === "activercomptevpn") {
                                    userloginfos.isActiverCompteVPN = true;
                                } else if (element.actiondroit === "achevercomptevpn") {
                                    userloginfos.isAcheverCompteVPN = true;
                                }

                                else if (element.actiondroit === "gererdemanderetrait") {
                                    userloginfos.isGererDemanderetrait = true;
                                } else if (element.actiondroit === "consulterdemanderetrait") {
                                    userloginfos.isConsulterDemanderetrait = true;
                                } else if (element.actiondroit === "creerdemanderetrait") {
                                    userloginfos.isCreerDemanderetrait = true;
                                } else if (element.actiondroit === "modifierdemanderetrait") {
                                    userloginfos.isModifierDemanderetrait = true;
                                } else if (element.actiondroit === "supprimerdemanderetrait") {
                                    userloginfos.isSupprimerDemanderetrait = true;
                                } else if (element.actiondroit === "importerdemanderetrait") {
                                    userloginfos.isImporterDemanderetrait = true;
                                } else if (element.actiondroit === "rejeterdemanderetrait") {
                                    userloginfos.isRejeterDemanderetrait = true;
                                } else if (element.actiondroit === "validerdemanderetrait") {
                                    userloginfos.isValiderDemanderetrait = true;
                                } else if (element.actiondroit === "annulerdemanderetrait") {
                                    userloginfos.isAnnulerDemanderetrait = true;
                                } else if (element.actiondroit === "confirmerretrait") {
                                    userloginfos.isConfirmerretrait = true;
                                }



                            });

                            await loginUser(userloginfos);
                            navigate("/");
                        } else {
                            setLoging(false);
                            showWarningMessage(textes.fr.norulesfound);
                        }
                    } else {
                        showErrorMessage(textes.fr.requestfail);
                        setFetching(false);
                        setLoging(false);
                    }
                })
            }

        })
            .catch((err) => {
                // console.log("error", err);
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
                setLoging(false);
            });
    }

    const handleAffectRulesForOne = async (profil, userloginfos, token, espace, code) => {
        // setLogin(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", token);
        myHeaders.append("cpte", code);
        myHeaders.append("prof", profil);
        myHeaders.append("conn", espace);

        // var urlencoded = new URLSearchParams();
        // urlencoded.append("code", profil);
        // urlencoded.append("prof", user.profil);
        // urlencoded.append("conn", user.token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/profiles/rights/${profil}`, requestOptions).then((response) => {

            if (response?.status !== 200) {
                showErrorMessage(textes.fr.serviceunavaillable);
                setLogin(false);
            } else {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        if (data.body?.data?.length !== undefined) {
                            clientarray = data?.body?.data;
                        } else {
                            clientarray.push(data?.body);
                        }

                        if (clientarray?.length !== 0) {
                            await clientarray.forEach(element => {
                                if (element.actiondroit === "fullaction") {
                                    userloginfos.isFullAction = true;
                                } else if (element.actiondroit === "adminaction") {
                                    userloginfos.isAdminAction = true;
                                }

                                else if (element.actiondroit === "gererdroit") {
                                    userloginfos.isGererDroit = true;
                                } else if (element.actiondroit === "consulterdroit") {
                                    userloginfos.isConsulterDroit = true;
                                } else if (element.actiondroit === "creerdroit") {
                                    userloginfos.isCreerDroit = true;
                                } else if (element.actiondroit === "modifierdroit") {
                                    userloginfos.isModifierDroit = true;
                                } else if (element.actiondroit === "supprimerdroit") {
                                    userloginfos.isSupprimerDroit = true;
                                } else if (element.actiondroit === "rechercherdroit") {
                                    userloginfos.isRechercherDroit = true;
                                } else if (element.actiondroit === "consulterdroitsprofil") {
                                    userloginfos.isConsulterDroitsProfil = true;
                                } else if (element.actiondroit === "modifierdroitsprofil") {
                                    userloginfos.isModifierDroitsProfil = true;
                                } else if (element.actiondroit === "desaffecterdroitprofil") {
                                    userloginfos.isDesaffecterDroitProfil = true;
                                } else if (element.actiondroit === "consulterdroitsespacetravail") {
                                    userloginfos.isConsulterDroitsEspaceTravail = true;
                                } else if (element.actiondroit === "modifierdroitsespacetravail") {
                                    userloginfos.isModifierDroitsEspaceTravail = true;
                                } else if (element.actiondroit === "desaffecterdroitespacetravail") {
                                    userloginfos.isDesaffecterDroitEspaceTravail = true;
                                }

                                else if (element.actiondroit === "gererdomaine") {
                                    userloginfos.isGererDomaine = true;
                                } else if (element.actiondroit === "consulterdomaine") {
                                    userloginfos.isConsulterDomaine = true;
                                } else if (element.actiondroit === "creerdomaine") {
                                    userloginfos.isCreerDomaine = true;
                                } else if (element.actiondroit === "modifierdomaine") {
                                    userloginfos.isModifierDomaine = true;
                                } else if (element.actiondroit === "supprimerdomaine") {
                                    userloginfos.isSupprimerDomaine = true;
                                } else if (element.actiondroit === "rechercherdomaine") {
                                    userloginfos.isRechercherDomaine = true;
                                }

                                else if (element.actiondroit === "gererclient") {
                                    userloginfos.isGererClient = true;
                                } else if (element.actiondroit === "consulterclient") {
                                    userloginfos.isConsulterClient = true;
                                } else if (element.actiondroit === "creerclient") {
                                    userloginfos.isCreerClient = true;
                                } else if (element.actiondroit === "modifierclient") {
                                    userloginfos.isModifierClient = true;
                                } else if (element.actiondroit === "supprimerclient") {
                                    userloginfos.isSupprimerClient = true;
                                } else if (element.actiondroit === "rechercherclient") {
                                    userloginfos.isRechercherClient = true;
                                }

                                else if (element.actiondroit === "gereresptrav") {
                                    userloginfos.isGererEspTrav = true;
                                } else if (element.actiondroit === "consulteresptrav") {
                                    userloginfos.isConsulterEspTrav = true;
                                } else if (element.actiondroit === "creeresptrav") {
                                    userloginfos.isCreerEspTrav = true;
                                } else if (element.actiondroit === "modifieresptrav") {
                                    userloginfos.isModifierEspTrav = true;
                                } else if (element.actiondroit === "supprimeresptrav") {
                                    userloginfos.isSupprimerEspTrav = true;
                                } else if (element.actiondroit === "rechercheresptrav") {
                                    userloginfos.isRechercherEspTrav = true;
                                }

                                else if (element.actiondroit === "gererprofil") {
                                    userloginfos.isGererProfil = true;
                                } else if (element.actiondroit === "consulterprofil") {
                                    userloginfos.isConsulterProfil = true;
                                } else if (element.actiondroit === "creerprofil") {
                                    userloginfos.isCreerProfil = true;
                                } else if (element.actiondroit === "modifierprofil") {
                                    userloginfos.isModifierProfil = true;
                                } else if (element.actiondroit === "supprimerprofil") {
                                    userloginfos.isSupprimerProfil = true;
                                } else if (element.actiondroit === "rechercherprofil") {
                                    userloginfos.isRechercherProfil = true;
                                } else if (element.actiondroit === "modifierprofilcompte") {
                                    userloginfos.isModifierProfilCompte = true;
                                } else if (element.actiondroit === "desaffecterprofil") {
                                    userloginfos.isDesaffecterProfil = true;
                                } else if (element.actiondroit === "consulterprofilcompte") {
                                    userloginfos.isConsulterProfilCompte = true;
                                }

                                else if (element.actiondroit === "gererutilisateur") {
                                    userloginfos.isGererUtilisateur = true;
                                } else if (element.actiondroit === "consulterutilisateur") {
                                    userloginfos.isConsulterUtilisateur = true;
                                } else if (element.actiondroit === "creerutilisateur") {
                                    userloginfos.isCreerUtilisateur = true;
                                } else if (element.actiondroit === "modifierutilisateur") {
                                    userloginfos.isModifierUtilisateur = true;
                                } else if (element.actiondroit === "supprimerutilisateur") {
                                    userloginfos.isSupprimerUtilisateur = true;
                                } else if (element.actiondroit === "rechercherutilisateur") {
                                    userloginfos.isRechercherUtilisateur = true;
                                }

                                else if (element.actiondroit === "gererconnexion") {
                                    userloginfos.isGererConnexion = true;
                                } else if (element.actiondroit === "consulterconnexion") {
                                    userloginfos.isConsulterConnexion = true;
                                }

                                else if (element.actiondroit === "gererincrement") {
                                    userloginfos.isGererIncrement = true;
                                } else if (element.actiondroit === "creerincrement") {
                                    userloginfos.isCreerIncrement = true;
                                } else if (element.actiondroit === "supprimerincrement") {
                                    userloginfos.isSupprimerIncrement = true;
                                }

                                else if (element.actiondroit === "gerermouchard") {
                                    userloginfos.isGererMouchard = true;
                                } else if (element.actiondroit === "consultermouchard") {
                                    userloginfos.isConsulterMouchard = true;
                                }

                                else if (element.actiondroit === "gerercompte") {
                                    userloginfos.isGererCompte = true;
                                } else if (element.actiondroit === "consultercompte") {
                                    userloginfos.isConsulterCompte = true;
                                } else if (element.actiondroit === "creercompte") {
                                    userloginfos.isCreerCompte = true;
                                } else if (element.actiondroit === "modifiercompte") {
                                    userloginfos.isModifierCompte = true;
                                } else if (element.actiondroit === "supprimercompte") {
                                    userloginfos.isSupprimerCompte = true;
                                } else if (element.actiondroit === "suspendrecompte") {
                                    userloginfos.isSuspendreCompte = true;
                                } else if (element.actiondroit === "activercompte") {
                                    userloginfos.isActiverCompte = true;
                                } else if (element.actiondroit === "recherchercompte") {
                                    userloginfos.isRechercherCompte = true;
                                }

                                else if (element.actiondroit === "gererlicence") {
                                    userloginfos.isGererLicence = true;
                                } else if (element.actiondroit === "consulterlicence") {
                                    userloginfos.isConsulterLicence = true;
                                } else if (element.actiondroit === "creerlicence") {
                                    userloginfos.isCreerLicence = true;
                                } else if (element.actiondroit === "modifierlicence") {
                                    userloginfos.isModifierLicence = true;
                                } else if (element.actiondroit === "supprimerlicence") {
                                    userloginfos.isSupprimerLicence = true;
                                } else if (element.actiondroit === "suspendrelicence") {
                                    userloginfos.isSuspendreLicence = true;
                                } else if (element.actiondroit === "activerlicence") {
                                    userloginfos.isActiverLicence = true;
                                } else if (element.actiondroit === "acheverlicence") {
                                    userloginfos.isAcheverLicence = true;
                                } else if (element.actiondroit === "rechercherlicence") {
                                    userloginfos.isRechercherLicence = true;
                                } else if (element.actiondroit === "consulterlicenceclient") {
                                    userloginfos.isConsulterLicenceClient = true;
                                } else if (element.actiondroit === "gestioncontroleroomdps") {
                                    userloginfos.isConsulterControlRoom = true;
                                }

                                // gestion des droits de l'application rattaché à la sécurité

                                else if (element.actiondroit === "gererrevendeur") {
                                    userloginfos.isGererRevendeur = true;
                                } else if (element.actiondroit === "consulterrevendeur") {
                                    userloginfos.isConsulterRevendeur = true;
                                } else if (element.actiondroit === "creerrevendeur") {
                                    userloginfos.isCreerRevendeur = true;
                                } else if (element.actiondroit === "modifierrevendeur") {
                                    userloginfos.isModifierRevendeur = true;
                                } else if (element.actiondroit === "supprimerrevendeur") {
                                    userloginfos.isSupprimerRevendeur = true;
                                } else if (element.actiondroit === "importerrevendeur") {
                                    userloginfos.isImporterRevendeur = true;
                                } else if (element.actiondroit === "suspendrerevendeur") {
                                    userloginfos.isSuspendreRevendeur = true;
                                } else if (element.actiondroit === "activerrevendeur") {
                                    userloginfos.isActiverRevendeur = true;
                                }

                                else if (element.actiondroit === "gererabonnement") {
                                    userloginfos.isGererAbonnement = true;
                                } else if (element.actiondroit === "consulterabonnement") {
                                    userloginfos.isConsulterAbonnement = true;
                                } else if (element.actiondroit === "creerabonnement") {
                                    userloginfos.isCreerAbonnement = true;
                                } else if (element.actiondroit === "modifierabonnement") {
                                    userloginfos.isModifierAbonnement = true;
                                } else if (element.actiondroit === "supprimerabonnement") {
                                    userloginfos.isSupprimerAbonnement = true;
                                } else if (element.actiondroit === "importerabonnement") {
                                    userloginfos.isImporterAbonnement = true;
                                } else if (element.actiondroit === "suspendreabonnement") {
                                    userloginfos.isSuspendreAbonnement = true;
                                } else if (element.actiondroit === "activerabonnement") {
                                    userloginfos.isActiverAbonnement = true;
                                }

                                else if (element.actiondroit === "gerersite") {
                                    userloginfos.isGererSite = true;
                                } else if (element.actiondroit === "consultersite") {
                                    userloginfos.isConsulterSite = true;
                                } else if (element.actiondroit === "creersite") {
                                    userloginfos.isCreerSite = true;
                                } else if (element.actiondroit === "modifiersite") {
                                    userloginfos.isModifierSite = true;
                                } else if (element.actiondroit === "supprimersite") {
                                    userloginfos.isSupprimerSite = true;
                                } else if (element.actiondroit === "importersite") {
                                    userloginfos.isImporterSite = true;
                                } else if (element.actiondroit === "suspendresite") {
                                    userloginfos.isSuspendreSite = true;
                                } else if (element.actiondroit === "activersite") {
                                    userloginfos.isActiverSite = true;
                                } else if (element.actiondroit === "validersite") {
                                    userloginfos.isValiderSite = true;
                                }

                                else if (element.actiondroit === "gererhotspot") {
                                    userloginfos.isGererHotspot = true;
                                } else if (element.actiondroit === "consulterhotspot") {
                                    userloginfos.isConsulterHotspot = true;
                                } else if (element.actiondroit === "creerhotspot") {
                                    userloginfos.isCreerHotspot = true;
                                } else if (element.actiondroit === "modifierhotspot") {
                                    userloginfos.isModifierHotspot = true;
                                } else if (element.actiondroit === "supprimerhotspot") {
                                    userloginfos.isSupprimerHotspot = true;
                                } else if (element.actiondroit === "importerhotspot") {
                                    userloginfos.isImporterHotspot = true;
                                } else if (element.actiondroit === "suspendrehotspot") {
                                    userloginfos.isSuspendreHotspot = true;
                                } else if (element.actiondroit === "activerhotspot") {
                                    userloginfos.isActiverHotspot = true;
                                } else if (element.actiondroit === "validerhotspot") {
                                    userloginfos.isValiderHotspot = true;
                                }

                                else if (element.actiondroit === "gererforfait") {
                                    userloginfos.isGererForfait = true;
                                } else if (element.actiondroit === "consulterforfait") {
                                    userloginfos.isConsulterForfait = true;
                                } else if (element.actiondroit === "creerforfait") {
                                    userloginfos.isCreerForfait = true;
                                } else if (element.actiondroit === "modifierforfait") {
                                    userloginfos.isModifierForfait = true;
                                } else if (element.actiondroit === "supprimerforfait") {
                                    userloginfos.isSupprimerForfait = true;
                                } else if (element.actiondroit === "importerforfait") {
                                    userloginfos.isImporterForfait = true;
                                } else if (element.actiondroit === "suspendreforfait") {
                                    userloginfos.isSuspendreForfait = true;
                                } else if (element.actiondroit === "activerforfait") {
                                    userloginfos.isActiverForfait = true;
                                }

                                else if (element.actiondroit === "gerersouscription") {
                                    userloginfos.isGererSouscription = true;
                                } else if (element.actiondroit === "consultersouscription") {
                                    userloginfos.isConsulterSouscription = true;
                                }

                                else if (element.actiondroit === "gerertransaction") {
                                    userloginfos.isGererTransaction = true;
                                } else if (element.actiondroit === "consultertransaction") {
                                    userloginfos.isConsulterTransaction = true;
                                }

                                else if (element.actiondroit === "genererticket") {
                                    userloginfos.isGenererTicket = true;
                                } else if (element.actiondroit === "viderticket") {
                                    userloginfos.isViderTicket = true;
                                }

                                else if (element.actiondroit === "gererpublicite") {
                                    userloginfos.isGererPublicite = true;
                                } else if (element.actiondroit === "consulterpublicite") {
                                    userloginfos.isConsulterPublicite = true;
                                } else if (element.actiondroit === "creerpublicite") {
                                    userloginfos.isCreerPublicite = true;
                                } else if (element.actiondroit === "modifierpublicite") {
                                    userloginfos.isModifierPublicite = true;
                                } else if (element.actiondroit === "supprimerpublicite") {
                                    userloginfos.isSupprimerPublicite = true;
                                } else if (element.actiondroit === "importerpublicite") {
                                    userloginfos.isImporterPublicite = true;
                                } else if (element.actiondroit === "suspendrepublicite") {
                                    userloginfos.isSuspendrePublicite = true;
                                } else if (element.actiondroit === "activerpublicite") {
                                    userloginfos.isActiverPublicite = true;
                                } else if (element.actiondroit === "acheverpublicite") {
                                    userloginfos.isAcheverPublicite = true;
                                }

                                else if (element.actiondroit === "gerercomptevpn") {
                                    userloginfos.isGererCompteVPN = true;
                                } else if (element.actiondroit === "consultercomptevpn") {
                                    userloginfos.isConsulterCompteVPN = true;
                                } else if (element.actiondroit === "creercomptevpn") {
                                    userloginfos.isCreerCompteVPN = true;
                                } else if (element.actiondroit === "modifiercomptevpn") {
                                    userloginfos.isModifierCompteVPN = true;
                                } else if (element.actiondroit === "supprimercomptevpn") {
                                    userloginfos.isSupprimerCompteVPN = true;
                                } else if (element.actiondroit === "importercomptevpn") {
                                    userloginfos.isImporterCompteVPN = true;
                                } else if (element.actiondroit === "suspendrecomptevpn") {
                                    userloginfos.isSuspendreCompteVPN = true;
                                } else if (element.actiondroit === "activercomptevpn") {
                                    userloginfos.isActiverCompteVPN = true;
                                } else if (element.actiondroit === "achevercomptevpn") {
                                    userloginfos.isAcheverCompteVPN = true;
                                }

                                else if (element.actiondroit === "gererdemanderetrait") {
                                    userloginfos.isGererDemanderetrait = true;
                                } else if (element.actiondroit === "consulterdemanderetrait") {
                                    userloginfos.isConsulterDemanderetrait = true;
                                } else if (element.actiondroit === "creerdemanderetrait") {
                                    userloginfos.isCreerDemanderetrait = true;
                                } else if (element.actiondroit === "modifierdemanderetrait") {
                                    userloginfos.isModifierDemanderetrait = true;
                                } else if (element.actiondroit === "supprimerdemanderetrait") {
                                    userloginfos.isSupprimerDemanderetrait = true;
                                } else if (element.actiondroit === "importerdemanderetrait") {
                                    userloginfos.isImporterDemanderetrait = true;
                                } else if (element.actiondroit === "rejeterdemanderetrait") {
                                    userloginfos.isRejeterDemanderetrait = true;
                                } else if (element.actiondroit === "validerdemanderetrait") {
                                    userloginfos.isValiderDemanderetrait = true;
                                } else if (element.actiondroit === "annulerdemanderetrait") {
                                    userloginfos.isAnnulerDemanderetrait = true;
                                } else if (element.actiondroit === "confirmerretrait") {
                                    userloginfos.isConfirmerretrait = true;
                                }


                            });

                            await loginUser(userloginfos);
                            navigate("/");
                        } else {
                            showWarningMessage(textes.fr.norulesfound);
                        }
                    } else {
                        showErrorMessage(textes.fr.requestfail);
                        setLogin(false);
                    }
                })
            }

        })
            .catch((err) => {
                // console.log("error", err);
                showErrorMessage(textes.fr.serviceunavaillable);
                setLogin(false);
            });
    }


    // affichages
    return (
        <div className="app-container">
            <div className="row m-0">
                <div className="col-md-6 bg_primary leftlogin">
                    <div className="container">
                        <div className="desczone">
                            {/* <div className="desczone p-lg-5"> */}
                            {/* <h1 className="text-white title_login">{textes.fr.appname}</h1>
                            <p className="text-white desclogin">{textes.fr.appdesc}</p> */}
                            <div className="row">
                                <div className="col-md-12">
                                    <img src="/assets/imgs/bg_login5.png" className="w-100" alt="" />
                                    {/* <Player
                                        autoplay
                                        loop
                                        className="login-img"
                                        src="/assets/imgs/report1.json"
                                        // src="/assets/imgs/loop-papers.json"
                                        style={{ width: 800, display: "block", marginLeft: "auto", marginRight: "auto", marginTop: -16 }}
                                    >
                                    </Player> */}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="col-md-6 rightlogin" style={{ backgroundImage: "url('/assets/imgs/bg1.jpg')" }}>
                    <div className="container">
                        {!inscrptstate && !confirmstate && !forgotpassstate && !ressetpassstate && <div className="formzone">
                            {step === 0 && <div className="loginform rounded">
                                {sessionmsg !== null && <div className="row">
                                    <div className="col-md-12 mb-3 alert alert-danger">
                                        <span className="text-black">{sessionmsg?.msg}</span>
                                    </div>
                                </div>}
                                <img src="/assets/imgs/logo.png" className="logo-img mb-3 rounded" alt="not found" />
                                <h2 className="text_primary title_login2 text-center">{textes.fr.login}</h2>
                                <p className="mb-4 text-center formdesctext">{textes.fr.logindesc} <Link className="text_primary" style={{ cursor: "pointer" }} onClick={() => { setinscrptstate(true) }}>S'inscrire</Link></p>
                                <form style={{ width: "100%" }} onSubmit={handleLogin}>
                                    <div className="row">
                                        <div className="col-md-12 mb-3">
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="login">
                                                    <PersonCircle />
                                                </span>
                                                <input type="text"
                                                    className="form-control"
                                                    placeholder={textes.fr.signinlogininput}
                                                    aria-label="Username"
                                                    value={login}
                                                    onChange={(e) => setLogin(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="login">
                                                    <Lock />
                                                </span>
                                                <input type={!showpass ? "password" : "text"}
                                                    className="form-control"
                                                    placeholder={textes.fr.signinpassinput}
                                                    aria-label="Password"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                                <span className="input-group-text" onClick={() => setShowpass(!showpass)}>
                                                    {!showpass ? <Eye /> : <EyeSlash />}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 mb-4">
                                            <p className="mb-3 formdesctext"><Link className="text_primary" style={{ cursor: "pointer" }} onClick={() => { setforgotpassstate(true) }}>Mot de passe oublié?</Link></p>
                                        </div>
                                        <div className="col-md-12">
                                            <button type="submit"
                                                className="btn btn-primary float-right"
                                                disabled={login && password ? false : true}
                                            >
                                                {fetching && <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />} {textes.fr.loginbtn} <ArrowRight />
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>}

                            {step === 1 && <div className="loginform rounded">
                                <img src="/assets/imgs/blank.png" className="user-img mb-3 rounded" alt="not found" />
                                <p className="mb-4 text-center formdesctext">{textes.fr.continueas}</p>
                                {loging && <Spinner
                                    as="span"
                                    animation="border"
                                    size="lg"
                                    role="status"
                                    aria-hidden="true"
                                    style={{ display: "block", marginLeft: "auto", marginRight: "auto" }}
                                />}
                                <div className="row pl-md-4 pr-md-4 mt-4">
                                    {
                                        (profils.length > 0) && profils?.map((item, index) => (
                                            <button type="button" style={{ width: "100%", color: "black", }} className="btn btn-light mb-2"
                                                key={index}
                                                onClick={() => {
                                                    confirmLogin(item?.code, item?.esp);
                                                }}
                                            >
                                                <div className="col-md-12 d-flex justify-content-between align-items-center p-2">
                                                    <h5 className="mb-0">{item?.lib}</h5>
                                                    <ArrowRight style={{ fontSize: 24 }} />
                                                </div>
                                            </button>
                                        ))
                                    }

                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-12">
                                        <button type="button" onClick={() => { setStep(0) }}
                                            className="btn btn-danger d-block ml-auto mr-auto"
                                        >
                                            <Reply /> {textes.fr.cancel}
                                        </button>
                                    </div>
                                </div>
                            </div>}

                        </div>}
                        {inscrptstate && !conditionstate && <div className="formzone">
                            <div className="loginform rounded">
                                <img src="/assets/imgs/logo.png" className="logo-img mb-3 rounded" alt="not found" />
                                <h2 className="text_primary title_login2 text-center">{textes.fr.signin}</h2>
                                <p className="mb-4 text-center formdesctext">{textes.fr.signindesc} <Link className="text_primary" style={{ cursor: "pointer" }} onClick={() => { setinscrptstate(false) }}>Se Connecter</Link></p>
                                <form style={{ width: "100%" }} onSubmit={handleSignin}>
                                    {inscriptstep === 0 && <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <div className="input-group flex-nowrap">
                                                {/* <span className="input-group-text" id="firstname">
                                                    <PersonCircle />
                                                </span> */}
                                                <input type="text"
                                                    className="form-control"
                                                    placeholder="Entrez le nom"
                                                    aria-label="Noms"
                                                    value={firstname}
                                                    onChange={(e) => setfirstname(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <div className="input-group flex-nowrap">
                                                {/* <span className="input-group-text" id="lastname">
                                                    <PersonCircle />
                                                </span> */}
                                                <input type="text"
                                                    className="form-control"
                                                    placeholder="Entrez le prénom"
                                                    aria-label="Noms"
                                                    value={lastname}
                                                    onChange={(e) => setlastname(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="email">
                                                    <Envelope />
                                                </span>
                                                <input type="email"
                                                    className="form-control"
                                                    placeholder="Entrez votre adresse email"
                                                    aria-label="Adresse email"
                                                    value={email}
                                                    onChange={(e) => setemail(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="email">
                                                    <PhoneFill />
                                                </span>
                                                <input type="tel"
                                                    className="form-control"
                                                    placeholder="EX: 670000000"
                                                    aria-label="Numéro téléphone"
                                                    value={tel}
                                                    onChange={(e) => settel(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12 mb-4">
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="pass">
                                                    <Lock />
                                                </span>
                                                <input type={!showpass ? "password" : "text"}
                                                    className="form-control"
                                                    placeholder={textes.fr.signinpassinput}
                                                    aria-label="Password"
                                                    value={pass}
                                                    onChange={(e) => setpass(e.target.value)}
                                                />
                                                <span className="input-group-text" onClick={() => setShowpass(!showpass)}>
                                                    {!showpass ? <Eye /> : <EyeSlash />}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 mb-4">
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="pass">
                                                    <Lock />
                                                </span>
                                                <input type={!showpass ? "password" : "text"}
                                                    className="form-control"
                                                    placeholder={textes.fr.signinconfirmpassinput}
                                                    aria-label="Password"
                                                    value={confirmpass}
                                                    onChange={(e) => setconfirmpass(e.target.value)}
                                                />
                                                <span className="input-group-text" onClick={() => setShowpass(!showpass)}>
                                                    {!showpass ? <Eye /> : <EyeSlash />}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <div className="form-check">
                                                <input type="checkbox" id="accept"
                                                    className="form-check-input"
                                                    checked={accept}
                                                    onChange={handleaccept}
                                                />
                                                <label htmlFor="accept" className="mb-1 form-check-label">En utilisant l'Application et les Services, l'Utilisateur accepte les présentes <Link className="text_primary" style={{ cursor: "pointer" }} onClick={() => { setconditionstate(true) }}>conditions d'utilisation</Link> et s'engage à les respecter</label>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <button type="button"
                                                onClick={() => setinscriptstep(1)}
                                                className="btn btn-primary float-right"
                                                disabled={firstname && email && tel && pass === confirmpass && accept && pass !== email ? false : true}
                                            > Suivant <ArrowRight />
                                            </button>
                                        </div>
                                    </div>}

                                    {inscriptstep === 1 && <div className="row">
                                        <div className="col-md-12 mb-3">
                                            <label htmlFor="typeident" className="mb-1">Type de pièce d'identité</label>
                                            <Select
                                                id="typeident"
                                                name="typeident"
                                                placeholder={textes.fr.selectlabel}
                                                options={listtypeident}
                                                value={typeident}
                                                onChange={(selected) => {
                                                    settypeident(selected);
                                                    if (selected === null) {
                                                        setnumpi("");
                                                        setrectocni("");
                                                        setversocni("");
                                                        setpassport("");
                                                        setpassportimg("");
                                                    }
                                                }}
                                                isClearable
                                            />
                                        </div>
                                        {(typeident !== null && typeident["value"] === 0) && <div className="col-md-12 mb-3">
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="numpi">
                                                    <CreditCard />
                                                </span>
                                                <input type="numpi"
                                                    className="form-control"
                                                    placeholder="Entrez votre numéro de carte d'identité"
                                                    aria-label="Numéro carte d'identité"
                                                    value={numpi}
                                                    onChange={(e) => setnumpi(e.target.value)}
                                                />
                                            </div>
                                        </div>}
                                        {(typeident !== null && typeident["value"] === 0) && <div className="col-md-12 mb-3">
                                            <label htmlFor="cnirecto" className="form-label">Photo pièce d'identité recto</label>
                                            <input className="form-control" type="file" id="cnirecto" onChange={(e) => handleChangeFile(e, "CNIRECTO")} />
                                        </div>}
                                        {(typeident !== null && typeident["value"] === 0) && <div className="col-md-12 mb-3">
                                            <label htmlFor="cniverso" className="form-label">Photo pièce d'identité verso</label>
                                            <input className="form-control" type="file" id="cniverso" onChange={(e) => handleChangeFile(e, "CNIVERSO")} />
                                        </div>}
                                        {(typeident !== null && typeident["value"] === 1) && <div className="col-md-12 mb-3">
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="passport">
                                                    <CreditCard />
                                                </span>
                                                <input type="passport"
                                                    className="form-control"
                                                    placeholder="Entrez votre numéro de passeport"
                                                    aria-label="Numéro passeport"
                                                    value={passport}
                                                    onChange={(e) => setpassport(e.target.value)}
                                                />
                                            </div>
                                        </div>}
                                        {(typeident !== null && typeident["value"] === 1) && <div className="col-md-12 mb-3">
                                            <label htmlFor="passeportimg" className="form-label">Photo passeport</label>
                                            <input className="form-control" type="file" id="passeportimg" onChange={(e) => handleChangeFile(e, "PASSEPORT")} />
                                        </div>}

                                        <div className="col-md-12 mb-3">
                                            <div className="form-check">
                                                <input type="checkbox" id="fa"
                                                    className="form-check-input"
                                                    checked={fa}
                                                    onChange={handlefa}
                                                />
                                                <label htmlFor="fa" className="mb-1 form-check-label">Fourniture d'accès internet</label>
                                            </div>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <div className="form-check">
                                                <input type="checkbox" id="vpn"
                                                    className="form-check-input"
                                                    checked={vpn}
                                                    onChange={handlevpn}
                                                />
                                                <label htmlFor="vpn" className="mb-1 form-check-label">Accès VPN</label>
                                            </div>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <div className="form-check">
                                                <input type="checkbox" id="pub"
                                                    className="form-check-input"
                                                    checked={pub}
                                                    onChange={handlepub}
                                                />
                                                <label htmlFor="pub" className="mb-1 form-check-label">Publicité</label>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <button type="submit"
                                                className="btn btn-primary float-right"
                                                disabled={((typeident !== null && typeident["value"] === 0) && numpi && rectocni && versocni && (fa || pub)) ? false : ((typeident !== null && typeident["value"] === 1) && passport && passportimg && (fa || pub)) ? false : true}
                                            >
                                                {fetching && <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />} {textes.fr.signinbtn} <ArrowRight />
                                            </button>
                                            <button type="button"
                                                onClick={() => setinscriptstep(0)}
                                                className="btn btn-dark float-right mr-3"
                                            ><ArrowLeft /> Précédent</button>
                                        </div>
                                    </div>}
                                </form>
                            </div>
                        </div>}
                        {forgotpassstate && <div className="formzone">
                            <div className="loginform rounded">
                                <img src="/assets/imgs/logo.png" className="logo-img mb-3 rounded" alt="not found" />
                                <h2 className="text_primary title_login2 text-center">{textes.fr.forgotpass}</h2>
                                <p className="mb-4 text-center formdesctext">{textes.fr.signindesc} <Link className="text_primary" style={{ cursor: "pointer" }} onClick={() => { setforgotpassstate(false) }}>Se Connecter</Link></p>
                                <form style={{ width: "100%" }} onSubmit={handleForgetpass}>
                                    <div className="row">
                                        <div className="col-md-12 mb-3">
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="email">
                                                    <Envelope />
                                                </span>
                                                <input type="email"
                                                    className="form-control"
                                                    placeholder="Entrez votre adresse email"
                                                    aria-label="Adresse email"
                                                    value={email}
                                                    onChange={(e) => setemail(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <button type="submit"
                                                className="btn btn-primary float-right"
                                                disabled={email ? false : true}
                                            >
                                                {fetching && <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />} Envoyer <ArrowRight />
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>}
                        {ressetpassstate && <div className="formzone">
                            <div className="loginform rounded">
                                <img src="/assets/imgs/logo.png" className="logo-img mb-3 rounded" alt="not found" />
                                <h2 className="text_primary title_login2 text-center">{textes.fr.resetpass}</h2>
                                <p className="mb-4 text-center formdesctext">{textes.fr.signindesc} <Link className="text_primary" style={{ cursor: "pointer" }} onClick={() => { setressetpassstate(false) }}>Se Connecter</Link></p>
                                <form style={{ width: "100%" }} onSubmit={handleRessetPass}>
                                    <div className="row">
                                        <div className="col-md-12 mb-4">
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="pass">
                                                    <Lock />
                                                </span>
                                                <input type={!showpass ? "password" : "text"}
                                                    className="form-control"
                                                    placeholder={textes.fr.signinpassinput}
                                                    aria-label="Password"
                                                    value={pass}
                                                    onChange={(e) => setpass(e.target.value)}
                                                />
                                                <span className="input-group-text" onClick={() => setShowpass(!showpass)}>
                                                    {!showpass ? <Eye /> : <EyeSlash />}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-12 mb-4">
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="pass">
                                                    <Lock />
                                                </span>
                                                <input type={!showpass ? "password" : "text"}
                                                    className="form-control"
                                                    placeholder={textes.fr.signinconfirmpassinput}
                                                    aria-label="Password"
                                                    value={confirmpass}
                                                    onChange={(e) => setconfirmpass(e.target.value)}
                                                />
                                                <span className="input-group-text" onClick={() => setShowpass(!showpass)}>
                                                    {!showpass ? <Eye /> : <EyeSlash />}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <button type="submit"
                                                className="btn btn-primary float-right"
                                                disabled={pass === confirmpass ? false : true}
                                            >
                                                {fetching && <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />} {textes.fr.reset} <ArrowRight />
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>}
                        {confirmstate && <div className="formzone">
                            <div className="loginform rounded">
                                <img src="/assets/imgs/logo.png" className="logo-img mb-3 rounded" alt="not found" />
                                <h2 className="text_primary title_login2 text-center">{textes.fr.confirmaccount}</h2>
                                <p className="mb-4 text-center formdesctext">{textes.fr.confirmaccountdesc}</p>
                                <form style={{ width: "100%" }} onSubmit={handleConfirmSignin}>
                                    <div className="row">
                                        <div className="col-md-12 mb-3">
                                            <OtpInput
                                                className="w-100"
                                                value={otp}
                                                onChange={setotp}
                                                numInputs={6}
                                                renderSeparator={<span>-</span>}
                                                renderInput={(props) => <input {...props} />}
                                                inputStyle={{
                                                    border: "1px solid #CFD3DB",
                                                    borderRadius: "8px",
                                                    width: "54px",
                                                    height: "54px",
                                                    fontSize: "12px",
                                                    color: "#000",
                                                    fontWeight: "400",
                                                    caretColor: "#18a03a"
                                                }}
                                                focusStyle={{
                                                    border: "1px solid #18a03a",
                                                    outline: "none"
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-12">
                                            <button type="submit"
                                                className="btn btn-primary float-right"
                                                disabled={otp ? false : true}
                                            >
                                                {fetching && <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />} {textes.fr.confirm} <ArrowRight />
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>}
                        {inscrptstate && conditionstate && <div className="formzone">
                            <div className="loginform rounded" style={{ width: "80%" }}>
                                <img src="/assets/imgs/logo.png" className="logo-img mb-3 rounded" alt="not found" />
                                <h2 className="text_primary title_login2 text-center mb-4">{textes.fr.conditionslabel}</h2>
                                <div className="row" style={{ maxHeight: "512px", overflowY: "scroll" }}>
                                    <div className="col-md-12 mb-3">
                                        <h5 className="mb-2 text_primary">Article 1 : Définitions</h5>
                                        <p className="mb-3 formdesctext">
                                            <ul>
                                                <li className="ml-4 mb-2"><strong>Application</strong> désigne l'application web développée par YCONNEKT pour la gestion de réseaux Wi-Fi.</li>
                                                <li className="ml-4 mb-2"><strong>Services</strong>  désigne les services fournis par YCONNEKT à travers l'Application, notamment la gestion de réseaux Wi-Fi, la fourniture de statistiques et de rapports, et la mise à disposition de publicités.</li>
                                                <li className="ml-4 mb-2"><strong>Utilisateur</strong> désigne toute personne physique ou morale qui utilise l'Application et les Services.</li>
                                                <li className="ml-4 mb-2"><strong>Client</strong> désigne tout Utilisateur qui a souscrit à un abonnement annuel pour utiliser les Services.</li>
                                            </ul>
                                        </p>

                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <h5 className="mb-2 text_primary">Article 2 : Acceptation des conditions d'utilisation</h5>
                                        <p className="mb-3 formdesctext">L'Utilisateur accepte les présentes conditions d'utilisation lorsqu'il utilise l'Application et les Services. Les conditions d'utilisation sont considérées comme acceptées par l'Utilisateur dès lors qu'il utilise l'Application et les Services.</p>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <h5 className="mb-2 text_primary">Article 3 : Utilisation de l'Application et des Services</h5>
                                        <p className="mb-3 formdesctext">L'Utilisateur s'engage à utiliser l'Application et les Services de manière responsable et conforme aux lois et réglementations en vigueur. L'Utilisateur s'engage notamment à :</p>
                                        <p className="mb-3 formdesctext">
                                            <ul>
                                                <li className="ml-4 mb-2">Ne pas utiliser l'Application et les Services à des fins illicites ou contraires aux lois et réglementations en vigueur.</li>
                                                <li className="ml-4 mb-2">Ne pas utiliser l'Application et les Services pour diffuser des contenus illicites, obscènes ou contraires aux bonnes mœurs.</li>
                                                <li className="ml-4 mb-2">Ne pas utiliser l'Application et les Services pour collecter des informations personnelles sur les utilisateurs sans leur consentement.</li>
                                            </ul>
                                        </p>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <h5 className="mb-2 text_primary">Article 4 : Abonnement annuel</h5>
                                        <p className="mb-3 formdesctext">Le Client s'engage à payer un abonnement annuel de 50 000 FCFA (cinquante mille francs CFA) pour chaque site ajouté dans la plateforme. L'abonnement annuel est payable d'avance et est non remboursable.</p>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <h5 className="mb-2 text_primary">Article 5 : Commission sur les retraits</h5>
                                        <p className="mb-3 formdesctext">YCONNEKT percevra une commission de 8% sur chaque retrait de gains effectués sur la plateforme</p>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <h5 className="mb-2 text_primary">Article 6 : Propriété intellectuelle</h5>
                                        <p className="mb-3 formdesctext">L'Application et les Services sont la propriété exclusive de YCONNEKT. L'Utilisateur s'engage à ne pas utiliser, reproduire, modifier ou distribuer l'Application et les Services sans l'autorisation écrite préalable de YCONNEKT.</p>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <h5 className="mb-2 text_primary">Article 7 : Confidentialité</h5>
                                        <p className="mb-3 formdesctext">YCONNEKT s'engage à protéger la confidentialité des informations personnelles des Utilisateurs. YCONNEKT s'engage notamment à ne pas divulguer les informations personnelles des Utilisateurs à des tiers sans leur consentement.</p>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <h5 className="mb-2 text_primary">Article 8 : Responsabilité</h5>
                                        <p className="mb-3 formdesctext">YCONNEKT ne sera pas responsable des dommages ou pertes subis par l'Utilisateur en raison de l'utilisation de l'Application et des Services. YCONNEKT ne sera pas responsable des dommages ou pertes subis par l'Utilisateur en raison de la perte ou de la corruption de données.</p>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <h5 className="mb-2 text_primary">Article 9 : Résiliation du contrat</h5>
                                        <p className="mb-3 formdesctext">Le présent contrat peut être résilié par YCONNEKT en cas de non-paiement de l'abonnement annuel ou de non-respect des termes du présent contrat. Le présent contrat peut également être résilié par l'Utilisateur en cas de non-respect des termes du présent contrat par YCONNEKT.</p>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <h5 className="mb-2 text_primary">Article 10 : Loi applicable et juridiction</h5>
                                        <p className="mb-3 formdesctext">Le présent contrat est régi par les lois du Cameroun. Tout litige ou différend découlant de l'interprétation ou de l'exécution du présent contrat sera soumis à la juridiction des tribunaux du Cameroun.</p>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <p className="mb-3 formdesctext">En utilisant l'Application et les Services, l'Utilisateur accepte les présentes conditions d'utilisation et s'engage à les respecter</p>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-12">
                                        <button type="button"
                                            onClick={() => setconditionstate(false)}
                                            className="btn btn-dark float-right"
                                        > Fermer
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}